import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isThemeModalOpen: false,
};

const GeneralSlicer = createSlice({
  name: "generalSlicer",
  initialState,
  reducers: {
    toggleThemeModal: (state, action) => {
      if (typeof action?.payload !== "boolean")
        state.isThemeModalOpen = !state.isThemeModalOpen;
      else state.isThemeModalOpen = action.payload;
    },
  },
});

export const { toggleThemeModal } = GeneralSlicer.actions;

export default GeneralSlicer.reducer;
